import axios from 'axios';
import * as constants from '../shared/constants/constants';

const instance = axios.create({
    baseURL: constants.MANAGEMENT_API_URL
});

export default instance;